import React, { useState } from 'react'

import { AuthProvider } from './lib/auth'

import Pages from './pages'

export default () => {
  //Cognito認証が終わるまでPagesコンポーネントを表示しないためのState
  const [isLoaded, setIsLoaded] = useState(false)

  //認証が終わるまでPagesコンポーネントを表示しないため onLoaded を props で渡す
  return (
    <div id="container" className="">
      <AuthProvider onLoaded={() => setIsLoaded(true)}>
        {(isLoaded) && <Pages />}
      </AuthProvider>
    </div>
  )
}
